@if (activeItem) {
  <h1>{{ activeItem.label }}</h1>
}
<div class="ui-g submenuPage">
  <div [ngClass]="activeItem && activeItem.title ? 'ui-g-12 ui-md-7 ui-lg-8 ui-xl-8 columnLayout' : 'ui-g-12 columnLayout'">
    <div class="submenuContainerLeft">
      <ul>
        @for (item of children; track item) {
          <li>
            @if (item.items) {
              <img class="inlineicon" [hisImage]="'next'" >
            }
            @if (item.routerLink) {
              <a [routerLink]="item.routerLink" [queryParams]="item.queryParams">{{item.label}}</a>
            }
            @if (!item.routerLink) {
              <a [href]="item.url">{{item.label}}</a>
            }
            <p>{{item.title}}</p>
          </li>
        }
      </ul>
    </div>
  </div>

  @if (activeItem && activeItem.title) {
    <div class="ui-g-12 ui-md-5 ui-lg-4 ui-xl-4 columnLayout">
      <div class="submenuContainerRight">
        <h2>{{ 'cm.alu.common.boxes.informationTitle' |hisUi }}</h2>
        <p>{{ activeItem.title }}</p>
      </div>
    </div>
  }
</div>
